<template>
    <v-container fluid fill-height class="grey lighten">
        <v-layout justify-center align-center>
            <component :is="page"></component>
        </v-layout>
    </v-container>
</template>

<script>
  import Login from './Login.vue'
  import Signup from './Signup.vue'
  export default {
    name: 'auth',
    components: {
      Login,
      Signup
    },
    data () {
      return {}
    },
    props: ['page'],
    methods: {}
  }
</script>
<style>
    .title-card {
        display: inline-block;
        padding-left: 1.5rem;
        border-left: 4px solid #da7266;
    }
    .wrapper-card-rounded {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
    .card-rounded {
        width: 300px;
        height: 285px!important;
        border-radius: 20px;
        position: relative;
        text-align: center;
    }
    .card-rounded  img {
        max-width: 100px;
        margin-top: -70px;
    }
    .btn-login {
        width: 208px;
    }
    .btn-login i {
        font-size: 1.5rem;
        margin-right: .5rem;
    }
    .coral {
      background-color: #da7266!important;
    }
    .fbblue {
      background-color: #3B5998!important;
    }
    h3.headline {
        height: 63px;
    }
    a.bordered {
        color: #9e9e9e;
        transition: all .3s ease-in-out;
    }
    a.bordered:hover {
        color: #da7266;
    }
    small a.bordered {
        color: #9e9e9e;
    }
    .grey.lighten {
      background-color: #8b8b8b;
    }
</style>
